<template>
  <div>
    <ion-menu  swipeGesture="false" side="end" menu-id="you-menu" content-id="main-content">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ t("Account & Support") }}</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>

        <ion-item color=primary @click="menuItemClick('home',null)">
          <ion-label>
            <b>{{ t("Home Menu") }}</b>
          </ion-label>
        </ion-item>

        <ion-accordion-group :value="accordionToOpen">
          <div v-for="group in menuGroups" v-bind:key="group.index + keyAdder" >
            <ion-accordion :value="group.value">
              <ion-item slot="header">
                <ion-label>
                  {{ group.label }}
                </ion-label>
                <ion-icon v-if="group.icon != undefined" :icon="group.icon" slot="end"></ion-icon>

              </ion-item>
              <ion-list slot="content">
                <div v-for="item in group.menuItems" v-bind:key="item.index + keyAdder">
                  <ion-item class="accordion_item">
                    <ion-label @click="menuItemClick(item,group)">
                        {{ item.label }}
                    </ion-label>
                    <ion-icon v-if="item.showCheckmark"  :icon="checkmarkCircleOutline" slot="end">
                    </ion-icon>
                    <ion-icon v-if="showIcon(item,'locked')" :icon="lockClosedOutline" slot="end">
                    </ion-icon>
                    <ion-icon v-if="showIcon(item,'offline')" :icon="offlineIcon" slot="end">
                    </ion-icon>
                    <ion-icon v-if="showIcon(item,'help')" @click="helpItemClick(item.program,item.label)" :icon="helpIcon" slot="end">
                    </ion-icon>
                  </ion-item>
                </div>
              </ion-list>
            </ion-accordion>
          </div>
        </ion-accordion-group>
        <ion-item>
          <ion-label color="secondary">
            Chessvis V{{ versionID }}<br>(c) 2025, Conceptual Software, Inc.
          </ion-label>
        </ion-item>
      </ion-content>
    </ion-menu>
  </div>
</template>

<script setup >

  import {IonIcon, IonLabel,IonMenuToggle, IonList,IonItem,IonAccordionGroup,
          IonAccordion, IonButtons, IonContent, IonHeader, IonMenu, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';

  import { informationOutline, informationCircle, lockClosedOutline, flashOffOutline,
          helpCircle, videocam, videocamOutline, bookOutline, medalOutline, checkmarkCircleOutline,
          extensionPuzzleOutline, eyeOffOutline, telescopeOutline, bodyOutline,
          caretForwardOutline , helpCircleSharp, helpCircleOutline, helpOutline,
          barChartOutline, eyeOutline , micOutline } from 'ionicons/icons';
  import { t } from '@/composables/translateText.js'

  import { ref, onMounted, onBeforeUnmount } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';

  const emit = defineEmits(['menu-item-click','menu-help-item-click'])

  const helpIcon = ref(informationCircle)
  const offlineIcon = ref(flashOffOutline)

  var isOffline = !navigator.onLine
  const keyAdder = ref(0)

  const connectionStore = useConnectionStore()

  const accordionToOpen = ref(connectionStore.getYouAccordionToOpen)

  const versionID = ref(connectionStore.versionID)
  const dummyRef = ref(connectionStore.getDummy)
  const isSubscriber = connectionStore.getIsSubscriber
  const subscriberText = ref((isSubscriber != 1) ? "Subscribe!" : "Subscriber: " +
              connectionStore.getSubscriberExpireDisplayString)

  // retrieve this flag from the server.  Only true for real users who have verify date != 0
  const isVerifiedOnServer = ref(connectionStore.getEmailVerified == "y" || connectionStore.getEmailVerified == "yes")

  // disable the menu item for dummy users or not verified real users
  const isVerifyDisabledFlag = ref(dummyRef.value != 0 || isVerifiedOnServer.value == true)

  const verifyText = ref("")

  const accountMenuItems = ref([
  ])

  const signinMenuItem = { index : 0, label : t("Signin"), program : "signin" }
  const registerMenuItem = { index : 1, label : t("Register"), program : "register" }
  const subscribeMenuItem = { index : 2, label : t("Subscribe"), program : "subscribe_blurb" }
  const preferenceMenuItem = { index : 3, label : t("Preferences & Languages"), program : "preferences" }
  const signoffMenuItem =   { index : 4, label : t("Signoff"), program : "signoff" }
  const verifyEmailMenuItem =   { index : 5, label : t("Verify Email Address"), program : "verify_email" }
  const emailVerifiedMenuItem =   { index : 6, label : t("Email Verified"), program : "", showCheckmark : true }
  const deleteMenuItem = { index : 7, label : t("Delete Account"), program : "delete_account" }
  const cancelSubscriptionMenuItem = { index : 8, label : t("Cancel Subscription"), program : "cancel_subscription" }

  const supportMenuItems = ref([
      { index : 0, label : t("Welcome & App Landing"), program : "welcome" },
      { index : 1, label : t("What's New") + " - " + connectionStore.versionDate, program : "whats_new" },
      { index : 2, label : t("Contact"), program : "contact" },
      { index : 3, label : t("Terms of Service"), program : "tos" }
    ])

    const videoMenuItems = ref([
      { index : 0, label : t("Opening - Find Opponent Moves"), program : "video_opponent_moves" },
      { index : 1, label : t("Opening - Find Your Best Moves"), program : "video_best_moves" },
      { index : 2, label : t("Repertoires!"), program : "video_repertoires" },
      { index : 3, label : t("Puzzle Visualization"), program : "video_puzzle_visualization" },
      { index : 4, label : t("Who's Guarding Whom"), program : "video_guarding" },
      { index : 5, label : "Whoo", program : "video_whoo" },
      { index : 6, label : t("Legacy - Repertoires"), program : "video_legacy_repertoires" },
      { index : 7, label : t("Legacy - Master Player Games"), program : "video_legacy_master" },
      { index : 8, label : t("Legacy - Play Game Collection"), program : "video_legacy_play_collection" },
    ])
    
    const bigButtonMenuItems = ref([
      { index : 0, label : t("Big Button Menu"), program : "big_button_menu" },
      { index : 1, label : t("Preferences"), program : "big_button_preferences" },
    ])

    const graphMenuItems = ref([
      { index : 0, label : "Your Games", program : "graph_your_games" },
    ])

    const menuGroups = ref([
      { index : 0 , value:"account",
                    label: t("Account"), menuItems : accountMenuItems.value},
      { index : 1 , value : "video", icon : videocamOutline,
                label : t("Videos - In English"), menuItems : videoMenuItems.value},
      { index : 2 , value : "bigbuttons", icon : eyeOutline,
                label : t("Big Buttons & EyeGaze"), menuItems : bigButtonMenuItems.value},
      { index : 3 , value:"support",
                    label : t("Support"), menuItems : supportMenuItems.value},

      // { index : 1 , value : "graphs", icon : barChartOutline,
      //           label : "Graphs & Stats", menuItems : graphMenuItems.value},
      
  ])

  onMounted(() => {
    // Experiment with this to time when to increment to force a rebuild
    keyAdder.value += 100

    //console.log("*** account menu mounted")

    // build the account based on user is signed in and/or subscriber
    accountMenuItems.value = []
    if (connectionStore.getDummy != 0) {
      accountMenuItems.value.push(signinMenuItem)
      accountMenuItems.value.push(registerMenuItem)
    }
    else {
      accountMenuItems.value.push(signoffMenuItem)
      if (connectionStore.getEmailVerified != "y")
        accountMenuItems.value.push(verifyEmailMenuItem)
      else
        accountMenuItems.value.push(emailVerifiedMenuItem)  
    }

    if (connectionStore.getSubscriberExpireDisplayString != "")
      subscribeMenuItem.label = t("Subscriber") + ": " + connectionStore.getSubscriberExpireDisplayString
    else
      subscribeMenuItem.label = t("Subscribe")
    accountMenuItems.value.push(subscribeMenuItem)
    accountMenuItems.value.push(preferenceMenuItem)
    accountMenuItems.value.push(deleteMenuItem)

    if (connectionStore.getSubscriberExpireDisplayString != "" && connectionStore.getSubscriberExpireDisplayString != "Perpetual")
        accountMenuItems.value.push(cancelSubscriptionMenuItem)
      
    menuGroups.value[0].menuItems = accountMenuItems.value
  })

  function showIcon(item,whichIcon) {
    //console.log("show Icon ",whichIcon,item,isSubscriber,isOffline)
    switch (whichIcon) {
      case "locked" :
        if (isSubscriber != 1 && item.subscriber === true)
          return (true)
        if (item.needsLichessToken === true && lichessAccessToken == "")
          return (true)
        return (false)
        break
      case "offline" :
        // stop showing offline
        return (false)

        // if (!isOffline)
        //   return (false)

        // // subscribers can do some things when off line
        // if (isSubscriber == 1 && item.canOfflineSubscriber === true)
        //     return (false)

        // // is the locked icon already displayed?
        // if (showIcon(item,"locked"))
        //   return (false)
        // return (true)
        break
      case "help" :
        if (item.help == undefined)
          return (false)
        if (item.help === false)
          return (false)
        if (showIcon(item,"offline"))
          return (false)
        if (showIcon(item,"locked"))
          return (false)
        return (true)
        break
    }
    return (false)
  }

  function menuItemClick(item,group) {

    if (item == "home") {
      connectionStore.setIsUsingNewMenus(true)
      emit("menu-item-click","home_menu",t("Home Menu"),"you")
      return
    }

    connectionStore.setYouAccordionToOpen(group.value)

    // email verified does nothing
    if (item.showCheckmark == true)
      return

    if (showIcon(item,"offline")) {
      setupAlert("You're Off-line","That program is only available when on-line","alert","offline")
      return
    }
    if (showIcon(item,"locked")) {
      if (item.needsLichessToken)
          setupAlert("Connect to Lichess","That program requires that you've connected to lichess and given Chessvis permission to play on your behalf","alert","lichesstoken")
      else
          setupAlert("Become A Subscriber?","That program is reserved for subscribers. Would you like to read about the benefits of subscribing?","yesno","subscribe")
      return
    }
    connectionStore.setIsUsingNewMenus(false)
    emit("menu-item-click",item.program,item.label,"you")
  }

  function helpItemClick(programName,label) {
    // setDirection('root')
    //console.log("**** HELP clicked ",programName)
    emit("menu-help-item-click",programName,label,"program")
  }

</script>

<style scoped>

.accordion_item:hover {
  color: red !important;
  font-weight: bold;
}

</style>
